import React from "react";
import Navigation from "./Navigation";

const CaseStudyLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main className="pt-20">
        {children}
      </main>
    </div>
  );
};

export default CaseStudyLayout;